import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { getErrorMessage } from '../../utils/errorHandler';
import expirationsAPI, { Expirations } from './expirationsAPI';

interface ExpirationsState {
  status: 'loading' | 'idle' | 'error' | 'success';
  error?: string;
  list?: Expirations;
}

export const initialState: ExpirationsState = {
  status: 'idle',
};

export const getExpirations = createAsyncThunk<
  Expirations,
  number,
  { rejectValue: string }
>('suscripciones/getExpirations', async (pagination, thunkAPI) => {
  try {
    const response = await expirationsAPI.getExpirations(pagination);

    if (response.status === 'error') {
      return thunkAPI.rejectWithValue(response.error);
    }

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(getErrorMessage(err));
  }
});

export const ExpirationsState = createSlice({
  name: 'ExpirationsState',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getExpirations.pending, state => {
        state.status = 'loading';
      })
      .addCase(getExpirations.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
      })
      .addCase(getExpirations.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const getExpirationList = (state: RootState) => state.expirations.list;

export const statusExpiration = (state: RootState) => state.expirations.status;

export default ExpirationsState.reducer;
